module.exports = __webpack_public_path__ + "images/banner-4.0c2f3136f3e88f1667612f7ab9f43e68.jpg";